var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"has-tooltip-left",style:(_vm.tooltipStyle),attrs:{"data-tooltip":_vm.tooltipText}})
}
var staticRenderFns = []

export { render, staticRenderFns }